import { render, staticRenderFns } from "./bay_window.vue?vue&type=template&id=2af498e7&scoped=true"
import script from "./bay_window.vue?vue&type=script&lang=js"
export * from "./bay_window.vue?vue&type=script&lang=js"
import style0 from "./bay_window.vue?vue&type=style&index=0&id=2af498e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af498e7",
  null
  
)

export default component.exports